"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");

var _mapInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/map");

var _flatMapInstanceProperty = require("@babel/runtime-corejs3/core-js/instance/flat-map");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.setResponseId = setResponseId;
exports.getAjaxExecutor = exports.withAuth = exports.setRequestDefaults = exports.ajaxRequestHeader = exports.xssiPrefix = void 0;

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/index-of"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/typeof"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _objectSpread3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _operators = require("rxjs/operators");

var _ajaxUtils = require("../ajax-utils");

var _logBusinessEventError = require("../telemetry/logBusinessEventError");

var _acquireToken = require("./acquireToken");

var _csrf = require("./csrf");

var _overrideSettings = require("../shared/override-settings/overrideSettings");

var xssiPrefix = /^\)\]\}',?\n/;
exports.xssiPrefix = xssiPrefix;
var ajaxRequestHeader = 'AjaxRequest'; // eslint-disable-next-line @typescript-eslint/no-explicit-any

exports.ajaxRequestHeader = ajaxRequestHeader;
var defaultOptions = {
  crossDomain: true,
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json'
  }
};

var setRequestDefaults = function setRequestDefaults(options) {
  defaultOptions = options;
};

exports.setRequestDefaults = setRequestDefaults;

var withAuth = function withAuth(ajax, acquireTokenOverride) {
  var ajaxProxy = function ajaxProxy(urlOrRequest) {
    var options;

    if (typeof urlOrRequest === 'string') {
      options = {
        url: urlOrRequest
      };
    } else {
      options = urlOrRequest;
    }

    var executeAjax = getAjaxExecutor(options, ajax);

    if (!options.anonymous) {
      var _options;

      return acquireTokenOverride ? acquireTokenOverride(options).pipe((0, _flatMapInstanceProperty(_operators))(executeAjax)) : (0, _acquireToken.acquireToken)((_options = options) === null || _options === void 0 ? void 0 : _options.audience).pipe((0, _flatMapInstanceProperty(_operators))(executeAjax));
    } else {
      return executeAjax();
    }
  };

  ajaxProxy.getJSON = function (url, headers) {
    var request;

    if (typeof url === 'string') {
      request = {
        url: url,
        headers: headers,
        method: 'GET'
      };
    } else {
      request = (0, _objectSpread3.default)((0, _objectSpread3.default)({
        headers: headers
      }, url), {}, {
        method: 'GET'
      });
    }

    return (0, _ajaxUtils.mapObservableJsonResponse)(ajaxProxy(request), request.noContentOverride);
  };

  ajaxProxy.postJSON = function (url, body, headers) {
    var request;

    if (typeof url === 'string') {
      request = {
        url: url,
        body: body,
        headers: headers,
        method: 'POST'
      };
    } else {
      request = (0, _objectSpread3.default)((0, _objectSpread3.default)({
        body: body,
        headers: headers
      }, url), {}, {
        method: 'POST'
      });
    }

    return (0, _ajaxUtils.mapObservableJsonResponse)(ajaxProxy(request), request.noContentOverride);
  };

  ajaxProxy.patchJSON = function (url, body, headers) {
    var request;

    if (typeof url === 'string') {
      request = {
        url: url,
        body: body,
        headers: headers,
        method: 'PATCH'
      };
    } else {
      request = (0, _objectSpread3.default)((0, _objectSpread3.default)({
        body: body,
        headers: headers
      }, url), {}, {
        method: 'PATCH'
      });
    }

    return (0, _ajaxUtils.mapObservableJsonResponse)(ajaxProxy(request), request.noContentOverride);
  };

  ajaxProxy.putJSON = function (url, body, headers) {
    var request;

    if (typeof url === 'string') {
      request = {
        url: url,
        body: body,
        headers: headers,
        method: 'PUT'
      };
    } else {
      request = (0, _objectSpread3.default)((0, _objectSpread3.default)({
        body: body,
        headers: headers
      }, url), {}, {
        method: 'PUT'
      });
    }

    return (0, _ajaxUtils.mapObservableJsonResponse)(ajaxProxy(request), request.noContentOverride);
  };

  ajaxProxy.deleteWithAuth = function (request) {
    var deleteRequest = (0, _objectSpread3.default)((0, _objectSpread3.default)({}, request), {}, {
      method: 'DELETE'
    });
    return ajaxProxy(deleteRequest);
  };

  ajaxProxy.get = function (url, headers) {
    return ajaxProxy({
      method: 'GET',
      url: url,
      headers: headers
    });
  };

  ajaxProxy.post = function (url, body, headers) {
    return ajaxProxy({
      method: 'POST',
      url: url,
      body: body,
      headers: headers
    });
  };

  ajaxProxy.put = function (url, headers) {
    return ajaxProxy({
      method: 'PUT',
      url: url,
      headers: headers
    });
  };

  ajaxProxy.patch = function (url, body, headers) {
    return ajaxProxy({
      method: 'PATCH',
      url: url,
      body: body,
      headers: headers
    });
  };

  ajaxProxy.delete = function (url, headers) {
    return ajaxProxy({
      method: 'DELETE',
      url: url,
      headers: headers
    });
  };

  return ajaxProxy;
};

exports.withAuth = withAuth;
var sessionIdHeader = 'ms-client-session-id';
var requestIdHeader = 'ms-client-request-id';
var correlationIdHeader = 'x-ms-correlation-id';
/**
 * @internal
 */

var getAjaxExecutor = function getAjaxExecutor(options, ajax) {
  return function (token) {
    var headers;

    if (token) {
      headers = {
        Authorization: 'Bearer ' + token
      };
    } else {
      headers = {};
    }

    if (options.useCsrf && options.method && options.method.toLowerCase() === 'post') {
      var csrfToken = _csrf.csrf.getToken();

      if (csrfToken) {
        headers = (0, _objectSpread3.default)((0, _objectSpread3.default)({}, headers), {}, {
          'X-XSRF-TOKEN': csrfToken
        });
      }
    }

    var sendSessionIdByDefault = process.env.APP_AJAX_ENABLE_AUTO_SESSION_ID === 'true';

    if (sendSessionIdByDefault && options.sendSessionId !== false || options.sendSessionId) {
      var _telemetryEmitter$get;

      var sessionIdHeaderKey = options.sessionIdHeader || process.env.APP_AJAX_SESSION_ID_HEADER || sessionIdHeader;
      var telemetryEmitter = (0, _overrideSettings.getOverrideSetting)('telemetryImplementation');
      var sessionId = telemetryEmitter === null || telemetryEmitter === void 0 ? void 0 : (_telemetryEmitter$get = telemetryEmitter.getSessionId) === null || _telemetryEmitter$get === void 0 ? void 0 : _telemetryEmitter$get.call(telemetryEmitter);

      if (sessionId) {
        headers = (0, _objectSpread3.default)((0, _objectSpread3.default)({}, headers), {}, (0, _defineProperty2.default)({}, sessionIdHeaderKey, sessionId));
      }
    }

    if (options.headers) {
      headers = (0, _objectSpread3.default)((0, _objectSpread3.default)((0, _objectSpread3.default)({}, defaultOptions.headers), headers), options.headers);
    } else {
      headers = (0, _objectSpread3.default)((0, _objectSpread3.default)({}, defaultOptions.headers), headers);
    }

    var requestOptions = (0, _objectSpread3.default)((0, _objectSpread3.default)((0, _objectSpread3.default)({}, defaultOptions), options), {}, {
      headers: headers
    });

    if (options.hasXssiResponse) {
      requestOptions.headers = (0, _objectSpread3.default)((0, _objectSpread3.default)({}, requestOptions.headers), {}, {
        AjaxRequest: true
      });
      requestOptions.responseType = 'text';
    }

    var ajaxResult = ajax(requestOptions);
    return ajaxResult.pipe((0, _mapInstanceProperty(_operators))(function (ajaxResponse) {
      if (options.hasXssiResponse) {
        if (ajaxResponse.status === 200 && typeof ajaxResponse.response === 'string') {
          ajaxResponse.responseType = 'json';

          var _body = ajaxResponse.response.replace(xssiPrefix, '');

          try {
            ajaxResponse.response = JSON.parse(_body);
          } catch (_unused) {
            ajaxResponse.response = null;
          }
        }
      }

      setResponseId(options, ajaxResponse);

      if (ajaxResponse.response && (0, _typeof2.default)(ajaxResponse.response) === 'object') {
        // We are extending the response to include the correlation Id from the controller.
        // We cannot rely on the options.meta object since some AjaxRequests don't populate this object.
        ajaxResponse.response.controllerCorrelationId = getControllerCorrelationIdHeaderValue(ajaxResponse);
      }

      return ajaxResponse;
    }), (0, _operators.catchError)(function (error) {
      if (error.status === 401 && options && options.audience) {
        (0, _logBusinessEventError.logBusinessEventError)('ajax-error/unauthorized', error);
      }

      var controllerCorrelationId = getControllerCorrelationIdHeaderValue(error);

      if (error.response && (0, _typeof2.default)(error.response) === 'object') {
        error.response.controllerCorrelationId = controllerCorrelationId;
      } else if (typeof error.response === 'string') {
        // This is the case for unhandled exceptions in the controller. The response contains the
        // server side error stack trace, so we are extending the payload by turning into an object
        // and  adding the correlation id.
        var errorResponse = error.response;
        error.response = {
          serverStackTrace: errorResponse,
          controllerCorrelationId: controllerCorrelationId
        };
      }

      throw error;
    }));
  };
};

exports.getAjaxExecutor = getAjaxExecutor;

function setResponseId(options, ajaxResponse) {
  var setRequestIdByDefault = process.env.APP_AJAX_ENABLE_AUTO_REQUEST_ID === 'true'; // Need to opt-in

  if (options.meta && (setRequestIdByDefault && options.setResponseRequestId !== false || options.setResponseRequestId)) {
    var meta = options.meta;
    var requestIdHeaderKey = options.responseRequestIdHeader || // per request header
    process.env.APP_AJAX_RESPONSE_REQUEST_ID_HEADER || // per app default header
    requestIdHeader; // default header

    var requestId = ajaxResponse.xhr.getResponseHeader(requestIdHeaderKey);

    if (!requestId && requestIdHeaderKey !== correlationIdHeader) {
      requestId = getControllerCorrelationIdHeaderValue(ajaxResponse);
    } // This mapping is only because IAMUX uses correlation id, however the standard practice
    // services is to use request id to identify requests accross services


    if (requestId) {
      meta.correlationId = requestId;
    }
  }
}

var getControllerCorrelationIdHeaderValue = function getControllerCorrelationIdHeaderValue(ajaxResponse) {
  var _context;

  var controllerCorrelationId = '';

  if (ajaxResponse && ajaxResponse.xhr && (0, _indexOf.default)(_context = ajaxResponse.xhr.getAllResponseHeaders()).call(_context, correlationIdHeader) >= 0) {
    controllerCorrelationId = ajaxResponse.xhr.getResponseHeader(correlationIdHeader);
  }

  return controllerCorrelationId;
};